<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['chartdata'],
  data(){
    return {
          options: {
            responsive: true,
            maintainAspectRatio: true,
            legend: {
              display: false,
              labels: {
                      // fontSize: 0,
                      fontColor: 'green'
                  }              
            },
            scales: {
              xAxes: [{
                ticks: {
                      display: false
                },
                gridLines: {
                    display:false
                }
              }],
              yAxes: [{
                ticks: {
                      display: false
                },
                gridLines: {
                    display:false
                }
              }]              
            }            
          }
    }
  },
  mounted () {
    this.renderChart(this.chartdata, this.options)
  }
}
</script>

<style>
</style>